
    require('./gauge/GaugeSeries');
    require('./gauge/GaugeView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/gauge.js
// module id = 1156
// module chunks = 158